import React from 'react';
import { IOptionAnyValue } from 'bricks/types';
import { NSDropdown } from 'bricks';

export interface IProps {
    label?: string;
    placeholder?: string;
    options: IOptionAnyValue[];
    onSelectOption: (option: IOptionAnyValue) => void;
}

export const AddToComparisonSimpleSelect = ({
    label = 'Add to comparison', placeholder, options, onSelectOption,
}: IProps) => (
    <div className="h-100 d-flex flex-column justify-content-center">
        <div className="text-white">{label}</div>
        <NSDropdown
            placeholder={placeholder}
            options={options}
            handleSelectOption={option => onSelectOption(option)}
        />
    </div>
);

export default AddToComparisonSimpleSelect;
